import { useViewStore } from '@/stores/useViewStore';

export const useCurrentCompanyId = () => {
  const { companyId } = useViewStore((state) => ({
    companyId: state.company ?? ``,
  }));
  return companyId;
};
